import * as ko from "knockout";
import { system } from "portalframework";
import * as _ from "lodash";
import * as entities from "entities";
import { RequestSearchCriteria } from "organized";
import { BaseService } from "./_common/_baseService";
import { portalHttpService } from "./_common/httpService";

class HelpDocumentsService extends BaseService {
  constructor() {
    super("help");
  }

  searchHelpDocuments = async (criteria: RequestSearchCriteria) => {
    const data: { count: number; result: any[] } = await portalHttpService.post<any>(
      system.apiURL() + "api/help/SearchHelpDocuments",
      ko.toJSON({ criteria: criteria })
    );
    let documents = [];
    if (data?.result) {
      documents = data.result.map((doc) => new entities.PortalHelpDocument(doc));
    }
    return {
      documents,
      count: data.count,
    };
  };
}

export const helpService = new HelpDocumentsService();
